import { render, staticRenderFns } from "./IcoachSkillPage.vue?vue&type=template&id=760c6ef4&"
import script from "./IcoachSkillPage.vue?vue&type=script&lang=ts&"
export * from "./IcoachSkillPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports